/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Region_AbdomenInputs */

const en_us2_bodymap_region_abdomen = /** @type {(inputs: Bodymap_Region_AbdomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abdomen`)
};

const pt_br2_bodymap_region_abdomen = /** @type {(inputs: Bodymap_Region_AbdomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abdômen`)
};

const es_419_bodymap_region_abdomen = /** @type {(inputs: Bodymap_Region_AbdomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abdomen`)
};

const pt_pt2_bodymap_region_abdomen = /** @type {(inputs: Bodymap_Region_AbdomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abdómen`)
};

const fr_fr2_bodymap_region_abdomen = /** @type {(inputs: Bodymap_Region_AbdomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abdomen`)
};

const de_de2_bodymap_region_abdomen = /** @type {(inputs: Bodymap_Region_AbdomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bauch`)
};

const it_it2_bodymap_region_abdomen = /** @type {(inputs: Bodymap_Region_AbdomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Addome`)
};

/**
* | output |
* | --- |
* | "Abdomen" |
*
* @param {Bodymap_Region_AbdomenInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_region_abdomen = /** @type {((inputs?: Bodymap_Region_AbdomenInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Region_AbdomenInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_region_abdomen(inputs)
	if (locale === "es-419") return es_419_bodymap_region_abdomen(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_region_abdomen(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_region_abdomen(inputs)
	if (locale === "de-DE") return de_de2_bodymap_region_abdomen(inputs)
	if (locale === "it-IT") return it_it2_bodymap_region_abdomen(inputs)
	return en_us2_bodymap_region_abdomen(inputs)
});
export { bodymap_region_abdomen as "bodymap.region.abdomen" }